import { W as WuiMenuPane$1, d as defineCustomElement$1 } from './p-CT2oAZeh.js';

const WuiMenuPane = WuiMenuPane$1;
const defineCustomElement = defineCustomElement$1;

export { WuiMenuPane, defineCustomElement };
